import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './EtchEndCap.scss';

const EtchEndCap = (props) => {

  useEffect(() => {
    const initTopDealsWidget = async () => {
      /* eslint-disable-next-line max-len */
      const { default: TopDealsWidget } = await import(/* webpackChunkName: "top-deals-widget" */ 'thd-events-widgets/dist/top-deals-widget.es6.umd');
      TopDealsWidget.init();
    };
    initTopDealsWidget();
  }, []);
  const { opts = {} } = props;
  const { id } = opts;

  return (
    <div className="etch-analytics" data-module-id={id} id="top-deals__wrapper" />
  );
};

EtchEndCap.propTypes = {
  opts: PropTypes.shape({}).isRequired
};

export default EtchEndCap;
